import React, { type FC } from 'react'
import cn from 'classnames'

import { type BaseProps, type RcbpTextRole } from 'types'
import styles from './style.scss'

export enum TextRoles {
  Title = 'TITLE',
  TitleLight = 'TITLE_LIGHT',
  Heading = 'HEADING',
  HeadingLite = 'HEADING_LITE',
  SubHeading = 'SUBHEADING',
  Body = 'BODY',
  SubtextBold = 'SUBTEXT_BOLD',
  Subtext = 'SUBTEXT',
  Caption = 'CAPTION',
  HelpText = 'HELP_TEXT',
  Error = 'ERROR_TEXT',
}

export interface Props extends BaseProps {
  role?: TextRoles | RcbpTextRole
  className?: string
  lineClamp?: number
}

const Text: FC<Props> = ({ children, role = TextRoles.Body, className, lineClamp = 0 }) => {
  const roleToClass = (role: string): string => {
    return role.toLowerCase().replace('_', '-')
  }
  const classNames = cn(styles['text'], styles[roleToClass(role)], className, {
    [styles['clamp']]: lineClamp,
  })

  return (
    <span
      className={classNames}
      style={{
        WebkitLineClamp: lineClamp,
      }}
    >
      {children}
    </span>
  )
}

export default Text
